"use strict";
/* eslint no-sync: 0 */

import angular from "angular";

const adminMenu = [
  {
    title: "用户",
    state: "user",
  },
  {
    title: "搜索",
    state: "search",
  },
  {
    title: "调研模板",
    state: "survey",
  },
  {
    title: "用户反馈",
    state: "feedback",
  },
  {
    title: "版本",
    state: "multiplication",
  },
  {
    title: "笔记",
    state: "notebook",
  },
  {
    title: "高亮",
    state: "highlight",
  },
  {
    title: "书签",
    state: "mark",
  },
  {
    title: "葡语语音类型",
    state: "speechtype",
  },
  {
    title: "葡语语音基本信息",
    state: "speechprofile",
  },
  {
    title: "葡语语音专辑",
    state: "speechdetails",
  },
  {
    title: "英语语音类型",
    state: "speechtypeen",
  },
  {
    title: "英语语音基本信息",
    state: "speechprofileen",
  },
  {
    title: "英语语音专辑",
    state: "speechdetailsen",
  },
  {
    title: "西语语音类型",
    state: "speechtypees",
  },
  {
    title: "西语语音基本信息",
    state: "speechprofilees",
  },
  {
    title: "西语语音专辑",
    state: "speechdetailses",
  },
  {
    title: "支付订单",
    state: "paysub",
  },
  {
    title: "广告支付订单",
    state: "adsub",
  },
  {
    title: "分享链接",
    state: "sharelink",
  },
  {
    title: "推送数据",
    state: "pushtoken",
  },
  {
    title: "推送设置列表",
    state: "custom",
  },
  {
    title: "每日一句",
    state: "oneday",
  },
  {
    title: "信息流",
    state: "new",
  },
  {
    title: "积分兑换设置",
    state: "setpoint",
  },
  {
    title: "ios统计数据导出",
    state: "iosdata",
  },
  {
    title: "分享图片上传",
    state: "shareimg",
  },
  {
    title: "计划类型",
    state: "plantype",
  },
  {
    title: "广告管理",
    state: "admanage",
  },
  {
    title: "邮件编辑器",
    state: "emaileditor",
  },
  {
    title: "故事",
    state: "story",
  },
  {
    title: "故事统计",
    state: "storyStat",
  },
  {
    title: "默认广告投放",
    state: "adDefaults",
  },
  {
    title: "默认广告投放（视频）",
    state: "adDefaultsVideo",
  },
  {
    title: "默认广告投放统计",
    state: "adDefaultStat",
  },
  {
    title: "☀广告聚合",
    state: "ad-aggregation",
  },
  {
    title: "☀Quiz",
    state: "quiz",
  },
  {
    title: "☀应用开关",
    state: "app-switch",
  },
  {
    title: "☀图片中心-通用",
    state: "common-images-center",
  },
  {
    title: "用户举报",
    state: "complaint",
  },
  {
    title: "读想祷配置",
    state: "uba",
  },
];
// {
//     title: '计划状态',
//     state: 'planstatus'
// }

const notAdminMenu = [
  {
    title: "用户",
    state: "user",
  },
  {
    title: "用户反馈",
    state: "feedback",
  },
  {
    title: "故事",
    state: "story",
  },
  {
    title: "故事统计",
    state: "storyStat",
  },
];

const feedback = [
  {
    title: "用户反馈",
    state: "feedback",
  },
  {
    title: "读想祷配置",
    state: "uba",
  },
];

export class NavbarComponent {
  /*@ngInject*/
  constructor($rootScope, $http, $cookies, $location) {
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$cookies = $cookies;
    this.$location = $location;
  }

  menu = [];

  isCollapsed = true;

  $onInit() {
    this.$rootScope.$on("changeAccount", () => {
      this.role();
    });

    this.role();
  }

  role() {
    const that = this;
    this.$http
      .get("/api/backstages/me", {
        header: {
          Accept: "application/json",
          "Content-Type": "application/json",
          token: this.$cookies.get("token"),
        },
      })
      .then(function (data) {
        console.log(`data.data.role: ${data.data.role}`);
        if (data && data.data) {
          if (data.data.role === "feedback") {
            that.menu = feedback;
            return;
          } else if (data.data.role !== "admin") {
            that.menu = notAdminMenu;
            return;
          }
        }
        that.menu = adminMenu;
      })
      .catch(function () {
        that.menu = adminMenu;
      });
  }

  loginOut() {
    this.menu = [];
    this.$cookies.remove("token");
    this.$location.path("main");
  }
}

export default angular.module("directives.navbar", []).component("navbar", {
  template: require("./navbar.html"),
  controller: NavbarComponent,
}).name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js